<template>
  <section class="pa-3">
    <v-subheader
      class="pa-0 mb-3"
      style="height: unset;"
    >
      <v-icon small>
        timer
      </v-icon>&nbsp;
      <span>Horarios de atención:</span>
    </v-subheader>
    <table class="caption small-table">
      <thead>
        <tr>
          <th>
            REGIONAL
          </th>
          <th>
            TURNO
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, key1, index1) in horarioAtencion"
          :key="index1"
        >
          <td>{{ key1 }}</td>
          <td>
            <div
              v-for="(hora, key,index) in item"
              :key="index"
            >
              <table class="caption small-table">
                <tbody>
                  <tr>
                    <th class="tituloHorario">
                      {{ hora.turno.toLowerCase() }}
                      <GlobalCardToolTip
                        prepend-icon="info"
                        icon-color="accent"
                        width="360px"
                        icon-size="18px"
                      >
                        <template #contenido>
                          <span v-html="hora.diasAtencion" />
                        </template>
                      </globalcardtooltip>
                    </th>
                  </tr>
                  <tr>
                    <td>
                      {{ hora.horaInicio.substring(0,5) }}- {{ hora.horaFin.substring(0,5) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>
<script >
import { mapActions } from 'vuex';
import typesDominios from "../store/types/Dominios.js";
import GlobalCardToolTip from "@/components/Global/GlobalCardToolTip.vue";

export default {
  name: 'Horario',
  components: {
    GlobalCardToolTip,
  },
  data(){
    return{
      horarioAtencion:''
    }
  },
  mounted(){
    if(localStorage.getItem('pObjDatosSession')){
      const datosSesion = JSON.parse(localStorage.getItem('pObjDatosSession'))
      this.ObtenerHorarioAtencion(datosSesion.oficinaId).then((r)=>{
        const datos = r.data
        this.horarioAtencion =this.groupBy(datos,"nombreOficina");
      })
    }
  },
  methods:{
    ...mapActions({
      ObtenerHorarioAtencion:typesDominios.actions.ObtenerHorarioAtencion
    }),

    groupBy(array, key) {
      return array.reduce((result, currentValue) => {
      const groupKey = typeof key === 'function' ? key(currentValue) : currentValue[key];
      if (!result[groupKey]) {
        result[groupKey] = [];
      }
      result[groupKey].push(currentValue);
      return result;
      }, {});
    }

  }
}
</script>

<style scoped>
.tituloHorario{
  text-transform: capitalize;
  font-size: 9px;
   padding: 2px 3px;
}
.small-table {
  font-size: 12px;
  border-collapse: collapse;
  width: 100%;
}

.small-table th,
.small-table td {
  padding: 4px 8px;
  border: 1px solid #ddd;
}

.small-table thead {
  background-color: #f5f5f5;
}

.small-table caption {
  font-size: 14px;
  padding: 8px;
  text-align: left;
}
.digital-clock {
  font-family: 'Digital-7', monospace;
  font-size: 12px;
  letter-spacing: 1px;
  padding: 7px;
  border-radius: 10px;
  text-align: center;
  width: 19px;
}
</style>
